import React from "react";
import './Success.less';

class Success extends React.Component {

  closeWindow() {
    window.WeixinJSBridge.call('closeWindow');
  }

  render() {
    return (
      <div className="success">
        <div className="content">
          <img
            src="https://assets.xiaomai5.com/res/xm/7dzQtRtPwr.png"
            alt=""
            className="image"
          />
          <div className="title">绑定成功</div>
          <div className="subtitle">【小麦钱包】可以提现到微信零钱账户了</div>
        </div>
        <div className="success-btn" onClick={this.closeWindow}>完成</div>
      </div>
    );
  }
}

export default Success;